import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import Api from '../../../../../services/Api';
import Button from '../../../../atoms/Button/Button';
import ProductTypeSelector from '../../../../atoms/ProductTypeSelector/ProductTypeSelector';
import DynastySelector from '../../../../atoms/DynastySelector/DynastySelector';
import CitySelector from '../../../../atoms/CitySelector/CItySelector';
import Icon from '../../../../atoms/Icon/Icon';
import './CreateProductModal.scss';

const CreateElementModal = ({
  onItemCreated,
  city,
  dynasty,
}) => {
  const [typeId, setTypeId] = useState(undefined);
  const [cityId, setCityId] = useState(city);
  const [dynastyId, setDynastyId] = useState(dynasty);
  const [name, setName] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(undefined);
  const saveComponent = () => {
    if (!typeId) {
      setError('Element type is required');
      return;
    }
    if (!cityId && !city) {
      setError('Element location is required');
      return;
    }
    if (!dynastyId && !dynasty) {
      setError('Element dynasty is required');
      return;
    }
    if (!name) {
      setError('Element name is required');
      return;
    }
    setLoading(true);
    Api.post('instances/building-products', {
      name,
      code_suffix: 'BPN',
      dynasty_id: dynastyId,
      city_id: cityId,
      product_type_id: typeId,
    }).then((response) => {
      setLoading(false);
      onItemCreated(response.data);
    });
  };
  return (
    <Row>
      <Col md={12}>
        <FormGroup>
          <Label>Type</Label>
          <ProductTypeSelector onChanged={e => setTypeId(e.value)} isMulti={false} />
        </FormGroup>
      </Col>
      {!city && (
        <Col md={12}>
          <FormGroup>
            <Label>Location</Label>
            <CitySelector onChanged={e => setCityId(e.value)} isMulti={false} />
          </FormGroup>
        </Col>
      )}
      {!dynasty && (
        <Col md={12}>
          <FormGroup>
            <Label>Dynasty</Label>
            <DynastySelector onChanged={e => setDynastyId(e.value)} isMulti={false} />
          </FormGroup>
        </Col>
      )}
      <Col md={12}>
        <FormGroup>
          <Label>Name</Label>
          <Input type="text" onChange={e => setName(e.target.value)} value={name} />
        </FormGroup>
      </Col>
      {error !== undefined && (
        <Col md={12} className="d-flex justify-content-end">
          <span className="text-danger">{error}</span>
        </Col>
      )}
      <Col className="d-flex justify-content-end mt-3">
        <Button isLoading={loading} onInvoked={() => saveComponent()}>
          <Icon icon="save" color="#fff" />
          <span className="ms-2">Save</span>
        </Button>
      </Col>
    </Row>
  );
};

CreateElementModal.propTypes = {
  onItemCreated: PropTypes.func.isRequired,
  city: PropTypes.number,
  dynasty: PropTypes.number,
};

CreateElementModal.defaultProps = {
  city: undefined,
  dynasty: undefined,
};

export default CreateElementModal;
